export default function SingleEventHtml(point) {
    return `
    ${point.pitch_name ? `<div>${point.pitch_name}</div>` : ''}
    ${point.batter_name ? `<div>Batter: ${point.batter_name}</div>` : ''}
    ${point.pitcher_name ? `<div>Pitcher: ${point.pitcher_name}</div>` : ''}
    ${point.game_date ? `<div>Date: ${point.game_date}</div>` : ''}

    ${
        point.release_speed
            ? `<div>Pitch Speed: ${point.release_speed}</div>`
            : ''
    }
    ${
        point.launch_speed
            ? `<div>Exit Velocity: ${point.launch_speed}</div>`
            : ''
    }
    ${
        !point.launch_speed && point.h_launch_speed
            ? `<div>Exit Velocity: ${point.h_launch_speed}</div>`
            : ''
    }
    ${
        !point.launch_speed && !point.h_launch_speed && point.hit_speed
            ? `<div>Exit Velocity: ${point.hit_speed}</div>`
            : ''
    }

    ${
        point.launch_angle
            ? `<div>Launch Angle: ${point.launch_angle}</div>`
            : ''
    }
    ${
        !point.launch_angle && point.h_launch_angle
            ? `<div>Launch Angle: ${point.h_launch_angle}</div>`
            : ''
    }
    ${
        !point.launch_angle && !point.h_launch_angle && point.hit_angle
            ? `<div>Launch Angle: ${point.hit_angle}</div>`
            : ''
    }

    ${
        !point.release_speed && point.start_speed
            ? `<div>Pitch Speed: ${point.start_speed}</div>`
            : ''
    }

    ${point.inning != null ? `<div>Inning: ${point.inning}</div>` : ''}

    ${
        point.balls != null
            ? `<div>Count: ${point.balls}-${point.strikes}</div>`
            : ''
    }
    ${
        point.outs_when_up != null
            ? `<div>Outs: ${point.outs_when_up}</div>`
            : ''
    }
    ${
        point.outs_when_up == null && point.outs != null
            ? `<div>Outs: ${point.outs}</div>`
            : ''
    }

    ${
        point.description
            ? `<div>Result: ${
                  point.nice_description
                      ? point.nice_description
                      : point.description
              }</div>`
            : ''
    }

    ${
        point.is_hit_into_play
            ? `<div>Contact Type: ${point.nice_contact_type}</div>`
            : ''
    }
    `
}
